import { SectionHeader } from "../sectionHeader";

export interface InfoDetail {
  label: string;
  value: string | JSX.Element;
  icon?: JSX.Element;
  className?: string;
}

export interface InfoSectionProps {
  title: string;
  details: InfoDetail[];
}

export function InfoSection({ title, details }: Readonly<InfoSectionProps>) {
  return (
    <div className="mb-3">
      <SectionHeader title={title} />
      <div>
        {details.map((detail, idx) => (
          <div
            key={idx}
            className={`d-flex flex-column flex-md-row justify-content-between py-2 px-3 ${
              idx < details.length - 1 ? "border-bottom" : ""
            }`}
          >
            <span className="text-muted fw-semibold mb-1 mb-md-0 flex-shrink-0 text-nowrap me-3"> 
              {detail.icon && <span className="me-2">{detail.icon}</span>}
              {detail.label}:
            </span>
            <span
              className={detail.className || "text-truncate"}
              style={{ minWidth: 0 }}
              title={typeof detail.value === "string" ? detail.value : undefined}
            >
              {detail.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default InfoSection;